import { Exception, ExceptionKey, ViolazioneInterface } from './Exception';
import { toastOnError } from '../../utils/toastUtils';
import { useCallback, useMemo } from 'react';
import useTypedIntl from '../../lang/utils/useTypedIntl';

const DEFAULT_PREFIX = 'exception.defaultError';

export default function useTranslatedException() {
    const { f } = useTypedIntl();

    const getTranslatedFormErrors = useCallback(
        (e: Exception): { [key: string]: string } => {
            const newFormErrors: { [key: string]: string } = {};
            const formErrors = e.getErroriForm();
            Object.entries(formErrors).forEach(([key, value]) => {
                newFormErrors[key] = f({ id: value });
            });
            return newFormErrors;
        },
        [f],
    );

    const getTranslatedViolations = useCallback(
        (e: Exception) => {
            if (!e.content.length) return;
            for (const { code, propertyPath } of e.content) {
                const withPropertyPath =
                    code.startsWith(DEFAULT_PREFIX) &&
                    propertyPath &&
                    propertyPath !== '';
                toastOnError(
                    (withPropertyPath ? `"${propertyPath}": ` : '') +
                        f({ id: code }),
                );
            }
        },
        [f],
    );

    const apiDefaultCatch = useCallback(
        (reason: any) => {
            try {
                const exception = Exception.fromResponse(reason.response);
                if (exception) {
                    if (exception.content === undefined) {
                        toastOnError(`Error: ${exception.status}`);
                    } else {
                        getTranslatedViolations(exception);
                        return reason.response;
                    }
                }
            } catch (error) {
                if (reason?.message) toastOnError(`Error: ${reason?.message}`);
                throw reason;
            }
        },
        [f],
    );

    const getTranslatedViolationsFromCodes = useCallback(
        (codes: ExceptionKey[]) => {
            codes.forEach((code) => {
                toastOnError(f({ id: code }));
            });
        },
        [f],
    );

    return useMemo(() => {
        return {
            apiDefaultCatch,
            getTranslatedFormErrors,
            getTranslatedViolations,
            getTranslatedViolationsFromCodes,
        };
    }, [
        getTranslatedViolations,
        getTranslatedFormErrors,
        getTranslatedViolationsFromCodes,
    ]);
}
